import { RefString, RefDate, RefNumber, RefBool, Collection } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { PersonalPickupStepRawData } from "./PersonalPickupStepRawData";
import { PersonalPickupStepState } from "./PersonalPickupStepState";


export class PersonalPickupStepData extends StepData
{
    public ItemsIds = new Collection<string>();
    public MeetingPlace = new RefString();
    public PlannedDispatchTime = new RefDate(new Date(0));
    public DispatchTime = new RefDate(new Date(0));
    public PaymentAtDelivery = new RefNumber(); // [LEGACY]
    public BasketSum = new RefNumber();
    public DepositSum = new RefNumber();
    public Training = new RefBool();
    public MeetupNotes = new RefString();
    public CustomerInfo = new RefString();

    constructor(raw: Partial<PersonalPickupStepRawData>)
    {
        super(raw);

        this.State.value ||= PersonalPickupStepState.NotPlannedYet;

        this.ItemsIds.Load(...raw?.ItemsIds || []);
        this.MeetingPlace.value = raw?.MeetingPlace || "";
        this.PlannedDispatchTime.value = new Date(raw?.PlannedDispatchTime || 0);
        this.DispatchTime.value = new Date(raw?.DispatchTime || 0);
        this.PaymentAtDelivery.value = raw?.PaymentAtDelivery || 0;
        this.BasketSum.value = raw?.BasketSum || 0;
        this.DepositSum.value = raw?.DepositSum || 0;
        this.MeetupNotes.value = raw?.MeetupNotes || "";
        this.Training.value = raw?.Training || false;
        this.CustomerInfo.value = raw?.CustomerInfo || "";
    }
}
